module.exports = __webpack_public_path__ + "img/Ignitemedialogo3.90e37b58.png";